import React from "react";
import img2 from "../../../assets/images/imgae-1.jpg";
import { MdAssistantDirection } from "react-icons/md";

const About = () => {
  return (
    <div className="text-white">
      <div className="hero min-h-screen">
        <div className="hero-content flex-col lg:flex-row-reverse">
          <img
            src={img2}
            className="max-w-sm  mask mask-decagon rounded-lg shadow-2xl"
            alt="banner"
          />
          <div className="">
            <h1 className="text-5xl font-bold mb-8"> Hi , I'm </h1>
            <p className="text-4xl text-pink-700">
              Alamin Sarker <br />
              <span className="text-2xl">Junior Full Stack Developer</span>
              <span className="text-xl"> <br/>
                Mohammadpur,Dhaka-1207,<br/> Bangladesh
              </span>
            </p>
            <div className="py-6 text-xl lg:max-w-md">
              Apart from coding, some other activities that I love to do! also
              Create simple game with python and play it, I loves lot
              <div className="flex flex-col">
                <div className="flex items-center text-2xl">
                  <span>
                    <MdAssistantDirection  className=" mr-2 text-pink-600" />
                  </span>
                  <p>Playing Games</p>
                </div>
                <div className="flex items-center ">
                <span>
                  <MdAssistantDirection className="mr-2 text-pink-600" />
                </span>
                <p> Writhing Tech Blogs</p>
                </div>
                <div className="flex items-center">
                <p>
                  <MdAssistantDirection className="mr-2 text-pink-600" />
                </p>
                <span>Traveling</span>
                </div>
              </div>
            </div>
            <a
              target="_blank"
              href="https://drive.google.com/file/d/1AP9eB8uNkoxM6FynbjXWE3v1y25h3-G9/view"
            >
              <button className="btn bg-pink-600 hover:bg-pink-800 outline-none">
                Download Resume
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
